/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveTipoAjuste } from "../../../project/services/TipoAjusteService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  descripcion: "",
  sumaResta: "",
  observaciones: "",
};

const sumaRestaOptions = [
  {
    id: "suma",
    descripcion: "Suma",
  },
  {
    id: "resta",
    descripcion: "Resta"
  }
];

const nameItemText = "Tipo de Ajuste";
const itemGender = "M";
// const elLa = itemGender === "M" ? "el" : "la";
// const unUna = itemGender === "M" ? "un" : "una";
//
// ########################################################################### 
//
const TipoAjusteDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.sumaResta === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Tipo de Ajuste",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {
    let _itemCrud = {
      descripcion: itemCrudLocal.descripcion,
      suma_resta: itemCrudLocal.sumaResta,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveTipoAjuste(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>

            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth sx={{ width: "100%", mb: 1 }}>
                  <InputLabel id="tipo-ajuste-select-label">
                    Tipo de Ajuste
                  </InputLabel>
                  <Select
                    labelId="sumaResta"
                    label="Tipo de Ajuste"
                    id="sumaResta"
                    name="sumaResta"
                    value={itemCrudLocal.sumaResta}
                    size="small"
                    onChange={handleChange}
                    disabled={actionCrud === "disable" || actionCrud === "enable"}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {sumaRestaOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>


            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcion"
                  label="Descripción"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={itemCrudLocal.descripcion}
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />

            </Grid>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <Button
              sx={{ mr: 1, backgroundColor: "warning" }}
              variant="contained"
              onClick={handleSave}
              startIcon={
                actionCrud === "disable" ? (
                  <RemoveCircleOutlineIcon />
                ) : actionCrud === "enable" ? (
                  <AddCircleOutlineIcon />
                ) : (
                  <SaveIcon />
                )
              }
            >
              {actionCrud === "disable"
                ? "Deshabilitar"
                : actionCrud === "enable"
                  ? "Habilitar"
                  : "Guardar"}
            </Button>
            <Button
              sx={{ mr: 2 }}
              variant="outlined"
              onClick={handleCloseDialog}
            >
              Cancelar
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default TipoAjusteDialog;
